/*const ornamentImages = [
    { url: `${process.env.REACT_APP_API_URL}/static/images/jar_1.png`, label: "Jar 1" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/jar_2.png`, label: "Jar 2" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/jar_3.png`, label: "Jar 3" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/teri_1.png`, label: "Teri 1" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/teri_2.png`, label: "Teri 2" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/teri_3.png`, label: "Teri 3" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/tako_1.png`, label: "Tako 1" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/tako_2.png`, label: "Tako 2" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/star_3.png`, label: "Star 1" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/star_2.png`, label: "Star 2" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/astronaut.png`, label: "Astronaut" },
    { url: `${process.env.REACT_APP_API_URL}/static/images/chicken.png`, label: "Chicken" },
];*/

const ornamentImages = [
    { url: '/static/images/jar_1.png', label: "Jar 1" },
    { url: '/static/images/jar_2.png', label: "Jar 2" },
    { url: '/static/images/jar_3.png', label: "Jar 3" },
    { url: '/static/images/teri_1.png', label: "Teri 1" },
    { url: '/static/images/teri_2.png', label: "Teri 2" },
    { url: '/static/images/teri_3.png', label: "Teri 3" },
    { url: '/static/images/tako_1.png', label: "Tako 1" },
    { url: '/static/images/tako_2.png', label: "Tako 2" },
    { url: '/static/images/star_3.png', label: "Star 1" },
    { url: '/static/images/star_2.png', label: "Star 2" },
    { url: '/static/images/astronaut.png', label: "Astronaut" },
    { url: '/static/images/chicken.png', label: "Chicken" },
];

export default ornamentImages;